import { useOutletContext } from "react-router-dom";
import GenericDashboard from "../../../../components/genericDashboard";
import FortigateVpnPanel from "../../../internal/3.0-dashboard/3.4-firewall/vpnPanel";

export default function DashFortigateCliente() {
  const outletProps = useOutletContext();

  return (
    <>
      {/* Painel customizado de VPNs no topo da dash */}
      <FortigateVpnPanel vpnListUrl="/cliente/home/vpnList" />
      {/* Conteúdo dinâmico (itens WAN etc.) renderizado pelo schema */}
      <GenericDashboard
        {...outletProps}
        api={outletProps.api}
        dash="fortigate"
        schemaUiUrl="/client/dash/schemaUIConfig"
        serieTemporalUrl="/cliente/zabbix/serieTemporal"
      />
    </>
  );
}
